module.exports = __webpack_public_path__ + "static/media/mc_lid_close.97cf64ee.svg";